<app-toasts-container></app-toasts-container>

@if (this.globalService.waitOverlayIsVisible$ | async) {
    <div class="processing-alert">
        <div class="inner">
            <div class="spinner spinner-border text-danger" role="status"></div>
            <p>{{ this.globalService.waitOverlayMessage$ | async }}</p>
        </div>
    </div>
}

@if (this.isLoggedIn) {
    <app-header></app-header>
}

<router-outlet />
